import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id F36D1111-54BF-4BB8-AE34-DE4809105551
 * name sort-ascending
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-ascending.svg
 * tags
 * - Text / Content / Format 
 */
export const SortAscendingIcon = createSvgIcon(<><path d="M19 17H22L18 21L14 17H17V3H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z" /></>, 'SortAscendingIcon');
export default SortAscendingIcon